const Youtube = () => (
  <svg
    width='32'
    height='32'
    viewBox='0 0 32 32'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_937_744)'>
      <path
        d='M32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16Z'
        fill='white'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.8136 9.41793C24.6746 9.64842 25.3513 10.3251 25.5818 11.1861C25.9983 12.7452 26 16.0001 26 16.0001C26 16.0001 26 19.255 25.5818 20.8141C25.3513 21.6751 24.6746 22.3518 23.8136 22.5822C22.2545 23.0004 16 23.0004 16 23.0004C16 23.0004 9.74547 23.0004 8.18636 22.5822C7.32532 22.3518 6.64867 21.6751 6.41818 20.8141C6 19.255 6 16.0001 6 16.0001C6 16.0001 6 12.7452 6.41818 11.1861C6.64867 10.3251 7.32532 9.64842 8.18636 9.41793C9.74547 8.99976 16 8.99976 16 8.99976C16 8.99976 22.2545 8.99976 23.8136 9.41793ZM13.9981 19L19.194 16.0004L13.9981 13.0007V19Z'
        fill='#121432'
      />
    </g>
    <defs>
      <clipPath id='clip0_937_744'>
        <rect width='32' height='32' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default Youtube
